export const FETCH_GOAL_REQUEST = 'FETCH_GOAL_REQUEST'
export const FETCH_GOAL_SUCCESS = 'FETCH_GOAL_SUCCESS'
export const FETCH_GOAL_FAILURE = 'FETCH_GOAL_FAILURE'
export const SET_GOAL_REQUEST = 'SET_GOAL_REQUEST'
export const SET_GOAL_SUCCESS = 'SET_GOAL_SUCCESS'
export const SET_GOAL_FAILURE = 'SET_GOAL_FAILURE'